/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import styles from './Styles'

const Event = (props) => {
  const { classes, theme} = props;
  const fields = props.events && props.events.fields;
  const imageUrl = fields && fields.imageEvents && fields.imageEvents.fields && fields.imageEvents.fields.file
    ? fields.imageEvents.fields.file.url
    : '';
  return (
    <div>
    { props.events ? (
    <Card className="content-card project-card" elevation={0}>
      <CardMedia
        className="content-card-media"
        image={imageUrl}
        title={fields.title}
      />
      <div className="content-card-body">
        <CardContent className="content-card-content">
          <span className="content-card-label">Project</span>
          <Typography component="h3" className="content-card-title">
          {fields.title}
          </Typography>
          <Typography variant="body2" className="content-card-meta">
            {fields.publishedAt || 'Professional project'}
          </Typography>
        </CardContent>
        <div className="content-card-actions">
          <Link to={{ pathname: '/eventdetails/'+fields.slug}} style={{textDecoration:'none'}}>
            <Button className="content-card-button" variant="contained">
                View project
            </Button>
          </Link>        
        </div>
      </div>
    </Card>
    ) : null}
    </div>
  );
}

Event.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Event);



// WEBPACK FOOTER //
// ./src/components/Events/Event.js